import React from "react";
import content from "../data/results/2024MrAmericacontent.json";
import ResultsPage from "./ResultsPage";

const Results2024MrAmerica = () => <ResultsPage content={content} />;

export default Results2024MrAmerica;
